import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { normalizeNonWrapUpfrontFeeRules } from "../helpers/investmentTransactionSettingsUtils";

const DEFAULT_SETTINGS = {
  nonWrapUpfrontFeeRules: normalizeNonWrapUpfrontFeeRules(),
};

const InvestmentTransactionSettingsContext = createContext(DEFAULT_SETTINGS);

export const InvestmentTransactionSettingsProvider = ({ children }) => {
  const [api] = useServerApi();
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    let active = true;

    const loadSettings = async () => {
      try {
        const result = await api.search({
          apiEntity: "setting",
          pageSize: 1,
        });
        if (!active) return;
        setSettings({
          nonWrapUpfrontFeeRules: normalizeNonWrapUpfrontFeeRules(
            result?.docs?.[0]?.investmentTransaction
          ),
        });
      } catch (error) {
        console.log(error);
      }
    };

    loadSettings();
    return () => {
      active = false;
    };
  }, []);

  const value = useMemo(
    () => settings,
    [settings.nonWrapUpfrontFeeRules]
  );

  return (
    <InvestmentTransactionSettingsContext.Provider value={value}>
      {children}
    </InvestmentTransactionSettingsContext.Provider>
  );
};

export const useInvestmentTransactionSettings = () =>
  useContext(InvestmentTransactionSettingsContext);
